import React from 'react';
import { styled } from 'styled-components';

const StyledFooter = styled.div`
  height: 450px;
  width: 100%;
  padding: 1em;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  text-align: center;
`;

export const Footer: React.FC = () => (
  <StyledFooter>
    <span>©2022 ADAC</span>
  </StyledFooter>
);
